import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, CircularProgress, Grid, Paper, TextField } from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';

import { GetCompany, GetRoles, PostCompanyCntctInfo } from '../services/httpServices';

// import { TextField } from '@material-ui/core';

const ContactInforamtion = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [roles, setRoles] = useState([]);

  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(true);

  const companyLegalNameRef = useRef('');
  const businessOperatingRef = useRef('');
  const companyGSTNumberRef = useRef('');
  const dateOfBusinessStartedRef = useRef('');
  const employerIdNumberRef = useRef('');
  const businessAddressRef = useRef('');
  const jobLocationRef = useRef('');
  const mailingAddressOfBusinessRef = useRef('');
  const employerNameRef = useRef('');
  const employerJobTitleRef = useRef('');
  const businessNumberRef = useRef('');
  const primaryContactRef = useRef('');
  const primaryFaxNumberRef = useRef('');
  const employerEmailAddressRef = useRef('');
  const companyWebsiteRef = useRef('');
  const [company, setCompany] = useState({});
  const fetchCompany = async (event) => {
    const company = await GetCompany(id);
    setCompany(company);
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, []);
  const SaveUser = async (event) => {
    setLoading(true);
    // setPosting(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      companyLegalName: companyLegalNameRef.current.value,
      businessOperating: businessOperatingRef.current.value,
      companyGst: companyGSTNumberRef.current.value,
      dateOfBusinessStarted: dateOfBusinessStartedRef.current.value,
      employerId: employerIdNumberRef.current.value,
      businessAddress: businessAddressRef.current.value,
      jobLocation: jobLocationRef.current.value,
      mailingAddress: mailingAddressOfBusinessRef.current.value,
      employerName: employerNameRef.current.value,
      employerJobTitle: employerJobTitleRef.current.value,
      businessPhoneNumber: businessNumberRef.current.value,
      primaryContactNumber: primaryContactRef.current.value,
      primaryFaxNumber: primaryFaxNumberRef.current.value,
      employerEmailAddress: employerEmailAddressRef.current.value,
      companyWebsite: companyWebsiteRef.current.value,
    };

    // console.log(payload);
    let response = await PostCompanyCntctInfo(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage("Company's Contact Information added successfully.");
      props.setSaved(true);
      props.setOpen(true);
      //console.log('Id:', id);
      let companySaved = company;
      companySaved.companyContactInformations[0] = response.data;
      setCompany(companySaved);
      // setTimeout(() => {
      //   navigate(`/app/EditCompany/${id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Company Operating Name"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyName}
                      disabled
                      inputRef={companyLegalNameRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Company G.S.T #"
                      variant="outlined"
                      fullWidth
                      size="small"
                      disabled
                      defaultValue={company.companyGst}
                      inputRef={companyGSTNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Company Website"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.companyWebsite}
                      inputRef={companyWebsiteRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Business Operating As"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.businessOperating}
                      inputRef={businessOperatingRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Date Of Business Started"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.dateOfBusinessStarted?.split('T')[0]}
                      inputRef={dateOfBusinessStartedRef}
                      InputLabelProps={{ shrink: true }}
                      type="date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Business Phone Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.businessPhoneNumber}
                      inputRef={businessNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Job Location"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.jobLocation}
                      inputRef={jobLocationRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={8}>
                    <TextField
                      label="Business Address"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.businessAddress}
                      inputRef={businessAddressRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={8}>
                    <TextField
                      label="Mailing Address of the Business"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.mailingAddress}
                      inputRef={mailingAddressOfBusinessRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Primary Fax Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.primaryFaxNumber}
                      inputRef={primaryFaxNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Employer's Name"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.employerName}
                      inputRef={employerNameRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Employer I.D Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.employerId}
                      inputRef={employerIdNumberRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Employer's Job Title"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.employerJobTitle}
                      inputRef={employerJobTitleRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Primary Contact Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.primaryContactNumber}
                      inputRef={primaryContactRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Employer's Email Address"
                      variant="outlined"
                      // type="email"
                      fullWidth
                      size="small"
                      defaultValue={company.companyContactInformations[0]?.employerEmailAddress}
                      inputRef={employerEmailAddressRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}></Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default ContactInforamtion;
